module.exports = __webpack_public_path__ + "media/images/front/icons/mypage-b2af51f205f966d5a3b94fde011170ee.png";